module.exports = __webpack_public_path__ + "static/media/tether.da702551.png";